import { render, staticRenderFns } from "./VehicleExtraDetails.vue?vue&type=template&id=744781a6&"
import script from "./VehicleExtraDetails.vue?vue&type=script&lang=js&"
export * from "./VehicleExtraDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports